export default (params) => ({
  trigger: {
    name: 'login.click_account_creation_intention_button',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          'create_account',
          'create_business_account',
        ],
      },
      sub_feature: {
        enum: [
          'header',
          'login',
          'account_creation',
        ],
      },
    },
    event: {
      name: 'select_content',
    },
  },
});
